<template>
    <!--弹窗-->
    <el-dialog
        width="80%"
        title="自建成本分析"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" label-width="300px" :rules="rules">
            <el-form-item label="">
                <el-button style="float: right" @click="autoAppend" size="mini" type="primary" :loading="appdLoading">
                    自动填充
                </el-button>
            </el-form-item>
            <el-form-item label="asin：" prop="asin">
                <el-input v-model="formData.asin" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入asin"></el-input>
            </el-form-item>
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="formData.state"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr_normal"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类目：" prop="keepa_category_id">
                <el-select v-model="formData.keepa_category_id" placeholder="请选择类目"
                           style="width: 300px;margin-right:20px;" size="mini" filterable>
                    <el-option v-for="item in categoryList" :key="item.id" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="图片链接：">
                <el-input style="width: 600px;" clearable v-model="formData.img_url" placeholder="请输入图片链接"
                          size="mini"></el-input>
                不填写按爬取的数据录入
            </el-form-item>

            <el-form-item label="标题：">
                <el-input style="width: 600px;" clearable v-model="formData.title" placeholder="请输入标题"
                          size="mini"></el-input>
                不填写按爬取的数据录入
            </el-form-item>
            <el-form-item label="销售价格：" prop="selling_price">
                <el-input-number
                    v-model="formData.selling_price"
                    style="width: 180px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入销售价格"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="品牌：">
                <el-input style="width: 150px;" clearable v-model="formData.brand" placeholder="请输入品牌"
                          size="mini"></el-input>
                不填写按爬取的数据录入
            </el-form-item>

            <el-form-item label="评分：">
                <el-input-number v-model="formData.rating" style="width: 300px;" :min="0" :step="0.1" :max="5"
                                 size="mini" placeholder="请输入评分"></el-input-number>
                不填写按爬取的数据录入
            </el-form-item>
            <el-form-item label="评论数：">
                <el-input-number v-model="formData.rating_count" style="width: 300px;" :min="0" :step="1" size="mini"
                                 placeholder="请输入评论数"></el-input-number>
                不填写按爬取的数据录入
            </el-form-item>

            <el-form-item label="搜索1688链接：">
                <el-button @click="choose1688" type="primary" size="mini" :loading="searchLoading">搜索1688链接
                </el-button>
            </el-form-item>

            <el-form-item label="1688产品链接：" prop="ali_href_link">
                <el-input v-model="formData.ali_href_link" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入1688产品链接"></el-input>
            </el-form-item>
            <el-form-item label="1688产品价格：" prop="ali_factory_price">
                <el-input v-model="formData.ali_factory_price" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入产品价格,且保留两位小数">
                </el-input>
            </el-form-item>
            <el-form-item label="1688产品图片：" style="position: relative">
                <el-input style="width: 300px;" clearable v-model="formData.ali_pic_url"
                          placeholder="请输入1688产品图片Url" size="mini"></el-input>
                <img style="width:90px;height:90px; position: absolute;z-index:10;left: 50%;top:-20px;"
                     :src="formData.ali_pic_url" v-show="formData.ali_pic_url"/>
            </el-form-item>

            <el-form-item label="1688产品标题：">
                <el-input style="width: 200px;" clearable v-model="formData.ali_title"
                          placeholder="请输入1688产品标题" size="mini"></el-input>
            </el-form-item>

            <el-form-item label="运输模式：" class="query-form-item">
                <el-select v-model="formData.deliver_mode" placeholder="请选择" size="mini" filterable>
                    <el-option :label="item.label" :value="item.value"
                               v-for="item in $common.deliverModeArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="标品类型：" class="query-form-item">
                <el-select v-model="formData.standard_product_type" placeholder="标品类型" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未录入" :value="-1"></el-option>
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in standardProductTypeArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="选品原则：" class="query-form-item">
                <el-select v-model="formData.selection_principle" placeholder="选品原则" size="mini">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in selectionPrincipleList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="退货率：">
                <el-input v-model="formData.refund_rate" style="width: 300px;margin-right:20px;" size="mini"
                          placeholder="请输入退货率">
                    <template slot="append">%</template>
                </el-input>
            </el-form-item>
            <el-form-item label="是否季节性：">
                <el-checkbox v-model="formData.is_seasonality">是否季节性</el-checkbox>
            </el-form-item>
            <el-form-item label="季节：" class="query-form-item">
                <el-select v-model="formData.season" placeholder="请选择" size="mini" filterable>
                    <el-option :label="item.label" :value="item.value" v-for="item in $common.seasonArr"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="长(cm)：">
                <el-input-number
                    v-model="formData.long"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入长(cm)"
                >
                </el-input-number>
                不填写按爬取的数据录入
            </el-form-item>
            <el-form-item label="宽(cm)：">
                <el-input-number
                    v-model="formData.wide"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入宽(cm)"
                >
                </el-input-number>
                不填写按爬取的数据录入
            </el-form-item>
            <el-form-item label="高(cm)：">
                <el-input-number
                    v-model="formData.height"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入高(cm)"
                >
                </el-input-number>
                不填写按爬取的数据录入
            </el-form-item>
            <el-form-item label="重(g)：">
                <el-input-number
                    v-model="formData.weight"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入重(kg)"
                >
                </el-input-number>
                不填写按爬取的数据录入
            </el-form-item>
        </el-form>


        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm" :loading="loading">添
                加
            </el-button
            >
        </el-row>

        <el-dialog title="是否要同时创建同Asin其他国家成本分析(如果存在)？" :visible.sync="dialogVisible"
                   :before-close="closeFunc" width="530px" append-to-body>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="addFunc(0)">否</el-button>
                <el-button size="mini" type="primary" @click="addFunc(1)">是</el-button>
              </span>
        </el-dialog>

        <categoryList :visible="showCategoryList" @choose1688Info="choose1688Info" :sendList="sendList"
                      @close-callback="showCategoryList=false"></categoryList>

    </el-dialog>


</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {selfbuild_get_ali_result} from '@/api/advAnalys/advAnalys.js'
import categoryList from './components/categoryList.vue'

export default {
    components: {categoryList},
    data() {
        return {
            sendList: [],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
            dialogVisible: false,
            appdLoading: false,
            categoryList: [],
            loading: false,
            showCategoryList: false,
            options: [],
            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择类目',
                        trigger: 'blur'
                    },
                ],
                state: [
                    {
                        required: true,
                        message: '请选择国家',
                        trigger: 'blur'
                    },
                ],
                asin: [
                    {
                        required: true,
                        message: '请输入asin',
                        trigger: 'blur'
                    },
                ],
                ali_href_link: [
                    {
                        required: true,
                        message: '请输入1688产品链接',
                        trigger: 'blur'
                    },
                ],
                ali_factory_price: [
                    {
                        required: true,
                        message: '请输入1688产品价格',
                        trigger: 'blur'
                    },
                ],
                selling_price: [
                    {
                        required: true,
                        message: '请输入销售价格',
                        trigger: 'blur'
                    },
                ],
            },
            formData: {
                deliver_mode: '',
                standard_product_type: '',
                selection_principle: '',
            },
            previewInfo: {},
            childInfoVisible: false,
            searchLoading: false,
            selectionPrincipleList:[],
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
    },
    watch: {
        visible: {
            handler(val) {
                val && this.getCategoryList()
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        choose1688() {
            this.searchLoading = true
            api.selfbuild_get_ali_result({
                state: this.formData.state,
                asin: this.formData.asin,
                img_url: this.formData.img_url,
            }).then(res => {
                if (res.code === 0) {
                    this.sendList = res.data || []
                    this.$set(this.formData, 'ali_result', res.data || [])
                    this.showCategoryList = true
                } else {
                    this.$notify({title: '提示', message: res.message, duration: 0});
                }
            }).finally(() => {
                this.searchLoading = false
            })
        },
        closeFunc() {
            this.dialogVisible = false
        },
        addFunc(num) {
            this.formData.is_need_other_state_data = num
            this.dialogVisible = false
            this.submitForm()
        },
        autoAppend() {
            this.appdLoading = true
            api.cost_analysis_selfbuild_autofill({
                asin: this.formData.asin,
                state: this.formData.state
            }).then(res => {
                this.appdLoading = false
                if (res.code === 0) {
                    const tempFormData = {...res.data, asin: this.formData.asin, state: this.formData.state}
                    tempFormData.keepa_category_id = res.data.keepa_category_id || undefined
                    this.$set(this, 'formData', tempFormData)
                    this.$message({type: 'success', message: '自动填充成功'})
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.appdLoading = false
            })
        },
        getCategoryList() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })

            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item=>{
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.childInfoVisible = false
            this.previewInfo = {}
            isShow == true && this.getList()
        },
        showInfo(title, info) {
            console.log('==')
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        choose1688Info(obj) {
            let {data, list} = obj
            this.$set(this.formData, 'ali_href_link', data.detail_url)
            this.$set(this.formData, 'ali_pic_url', data.pic_url)
            this.$set(this.formData, 'ali_factory_price', data.price)
            this.$set(this.formData, 'ali_title', data.title)
            this.showCategoryList = false
        },
        // 保存信息
        submitForm() {
            if(this.formData.is_seasonality && ['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '是季节性，需选择季节'})
                return
            }
            if(!this.formData.is_seasonality && !['', undefined, null].includes(this.formData.season)) {
                this.$message({type: 'error', message: '不是季节性，需清空选择的季节'})
                return
            }
            if(!this.formData.is_seasonality) {
                this.formData.season = ''
            }

            this.$refs['formData'].validate(valid => {
                if (valid) {
                    this.loading = true
                    api.cost_analysis_selfbuild_create({
                        keepa_category_id: this.formData.keepa_category_id,
                        asin: this.formData.asin,
                        state: this.formData.state,
                        title: this.formData.title,
                        brand: this.formData.brand,
                        season: this.formData.season,
                        rating: this.formData.rating,
                        rating_count: this.formData.rating_count,
                        ali_href_link: this.formData.ali_href_link,
                        ali_factory_price: this.formData.ali_factory_price,
                        ali_pic_url: this.formData.ali_pic_url,
                        ali_title: this.formData.ali_title,
                        refund_rate: this.accDiv(this.formData.refund_rate, 100),
                        is_seasonality: this.formData.is_seasonality ? 1 : 0,
                        long: this.formData.long,
                        wide: this.formData.wide,
                        height: this.formData.height,
                        weight: this.formData.weight,
                        selling_price: this.formData.selling_price,
                        deliver_mode: this.formData.deliver_mode,
                        standard_product_type: this.formData.standard_product_type,
                        selection_principle: this.formData.selection_principle,
                        ali_result: this.formData.ali_result,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({message: '创建成功', type: 'success'})
                            const tempVal = JSON.parse(JSON.stringify(res.data))
                            this.$emit('showDetail', tempVal)
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.formData = {
                deliver_mode: '',
                standard_product_type: '',
                selection_principle: '',
            }
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },

        accDiv(arg1, arg2) {
            let t1, t2
            t1 = this.getDecimalLength(arg1)
            t2 = this.getDecimalLength(arg2)
            if (t1 - t2 > 0) {
                return (this.getNum(arg1) / this.getNum(arg2)) / Math.pow(10, t1 - t2)
            } else {
                return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
            }
        },

        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.subTitle {
    font-size: 16px;
    font-weight: 900;
    margin: 20px 0;
}

.top1 {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .top1Right {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 12px 0 0;
                font-weight: 900;
            }

            .itemContent {
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top3 {
    display: flex;
    justify-content: space-between;
    width: 600px;

    .top3Left {
        width: 100px;
        height: 120px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        button {
            margin-top: 10px;
        }
    }

    .top3Right {
        width: 400px;

    }
}

.top4 {
    .line1, .line2, .line4, .line3 {
        display: flex;
        justify-content: start;
    }

    .itemInfo {
        width: 25%;
        display: flex;
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }

        .itemContent {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .line4 {
        .line4Left, .line4Right {
            width: 50%;
        }

        .itemInfo {
            width: 100%;
        }
    }

}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
